module.exports = __webpack_public_path__ + "img/verwirrt.ad4327a1.jpg";